import React, { Component } from 'react';

import Objectifs from '../../../components/Objectifs';
import ProjectContent from '../../../components/ProjectContent';
import '../../../css/views/project.css';
import jolotte1 from "../../../images/jolotte1-1.png";
import jolotte2 from "../../../images/jolotte1-2.png";
import jolotte3 from "../../../images/jolotte1-3.png";

export default class Jolotte extends Component {
	render() {
		const { img, objectives } = this.props;
		return (
			<div>
				<ProjectContent altTitle="Les enjeux de l'application mobile">
					<p className="text-detail">
						Les attentes des consommateurs ont évolué : soucieux de l'impact de
						leurs modes de vie sur leur santé, ils recherchent{' '}
						<strong>le bien-être sans négliger la santé</strong>.
					</p>
					<p className="text-detail">
						Aujourd'hui, alors que la population considère la santé comme un
						investissement, les consommateurs souhaitent des produits alliant
						efficacité, sécurité et innovation.
					</p>
					<p className="text-detail left">Ils attendent :</p>
					<ul className="text-detail left">
						<li>
							- une information <strong>fiable</strong>, factuelle, impartiale,
							précise et à jour,
						</li>
						<li>
							- une information <strong>utile</strong>, claire, simple et
							compréhensible,
						</li>
						<li>
							- une information <strong>accessible</strong>. Ce besoin
							d'information doit inciter les fabricants à être plus transparents
							pour répondre au besoin de sécurité exprimé par les consommateurs.
						</li>
					</ul>
					<p className="text-detail">
						Ce besoin d'information doit inciter les fabricants à être plus transparents pour répondre au besoin de sécurité exprimé par les consommateurs.
						Consommateur comme fabricant ou distributeur, <strong>l'information est au
						coeur de toutes les préoccupations</strong>, bien qu'elle ne réponde pas aux
						mêmes besoins. Le digital est un moyen de dématérialiser
						l'information pour répondre à toutes ces attentes. C'est dans cet
						esprit que l'application mobile JOLOTTE a été créée.
					</p>
				</ProjectContent>

				<Objectifs src={img} objectives={objectives} />

				<ProjectContent
					mecanique
					subtitle="Un outil de cosmétovigilance sous forme d’application beauté."
				>
					<p className="text-detail">
						<strong>Comment prendre soin de soi sans se mettre en danger ?</strong><br/> C'est la
						question à laquelle l'application mobile JOLOTTE peut répondre.<br/>
						JOLOTTE est une application mobile qui permet de suivre de près sa
						trousse de toilette.<br/> Grâce à Jolotte, on peut <strong>composer son vanity
						virtuel</strong> en enregistrant ses produits cosmétiques et les utiliser en
						toute confiance, grâce aux informations claire et fiables de
						l'application.
					</p>
					<div className="caption gallery">
						<img src={jolotte1} alt=""/>
						<img src={jolotte2} alt=""/>
						<img src={jolotte3} alt=""/>
					</div>
				</ProjectContent>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/projet/fiches/Jolotte.js